// Build a map of userId → rating for O(1) lookup
export const buildRatingMap = (ratingData = []) => {
  if (!Array.isArray(ratingData)) return {};  // ← guard if undefined is passed

  return ratingData.reduce((map, r) => {
    const userId = r.user?.[0]; // user is an array with one id
    if (userId) map[userId] = r.rating;
    return map;
  }, {});
};

// Returns filled/empty star array for a given rating value
export const getStarArray = (rating = 0, max = 5) => {
  if (!rating && rating !== 0) return []; // ← always return array, never null
  return Array.from({ length: max }, (_, i) => i + 1 <= Math.round(rating));
};

// Computes average rating and per-star breakdown
export const computeRatingStats = (ratingData = []) => {
  if (!ratingData.length) return { average: 0, total: 0, breakdown: {} };

  const total = ratingData.length;
  const sum = ratingData.reduce((acc, r) => acc + (r.rating || 0), 0);
  const average = Math.round((sum / total) * 10) / 10; // e.g. 4.3

  // Count per star: { 1: 0, 2: 0, 3: 2, 4: 1, 5: 4 }
  const breakdown = ratingData.reduce((acc, r) => {
    const star = r.rating;
    acc[star] = (acc[star] || 0) + 1;
    return acc;
  }, {});

  return { average, total, breakdown };
};